import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getUser, subscribeAuth } from '../utils/auth';

function PersonIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

function initials(user) {
  const name = (user?.name || user?.email || '?').trim();
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

function AccountButton() {
  const [user, setUser] = useState(getUser);
  useEffect(() => subscribeAuth(setUser), []);

  if (user) {
    return (
      <Link to="/account" className="lng-account-btn" aria-label="Your account">
        {user.picture ? (
          <img src={user.picture} alt="" referrerPolicy="no-referrer" />
        ) : (
          <span>{initials(user)}</span>
        )}
      </Link>
    );
  }

  return (
    <Link to="/account" className="lng-icon-btn" aria-label="Sign in to save recordings">
      <PersonIcon />
    </Link>
  );
}

export default AccountButton;
